import { useEffect } from 'react';
import FJImageExtenderLeftContainer from './FJImageExtenderLeft/container/FJImageExtenderLeftContainer';
import FJImageExtenderRightContainer from './FJImageExtenderRight/container/FJImageExtenderRightContainer';
import { useDispatch } from 'react-redux';
import FJActionImageExtender from '../../redux/action/FJActionImageExtender';

const FJImageExtender = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionImageExtender.initImageExtenderDataAction());
    }, [dispatch]);

    return (
        <>
            <FJImageExtenderLeftContainer />
            <FJImageExtenderRightContainer />
        </>
    );
};

export default FJImageExtender;
